import * as React from 'react';
export default function SvgPostscriptAi() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.843 9.246c-1.048.908-1.593 2.217-1.593 3.868v5.093c0 .14.113.251.25.25 1.76-.006 5.375-.018 7-.018 3.674 0 5.422-1.134 6.283-2.255.889-1.157.967-2.47.967-3.07a.75.75 0 0 1 1.5 0c0 .706-.084 2.43-1.277 3.983-1.22 1.59-3.473 2.841-7.473 2.841-1.621 0-5.234.013-6.995.02a1.749 1.749 0 0 1-1.755-1.75v-5.094c0-2 .675-3.757 2.111-5.002C6.283 6.88 8.356 6.232 11 6.232a.75.75 0 0 1 0 1.5c-2.417 0-4.094.593-5.157 1.514Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.48 5.8c-.217-1.067-1.743-1.067-1.96 0l-.277 1.364a2 2 0 0 1-1.561 1.561l-1.363.277c-1.068.217-1.068 1.743 0 1.96l1.363.277a2 2 0 0 1 1.56 1.562l.278 1.363c.217 1.067 1.743 1.067 1.96 0l.277-1.363a2 2 0 0 1 1.561-1.562l1.363-.277c1.068-.217 1.068-1.743 0-1.96l-1.363-.277a2 2 0 0 1-1.56-1.561L16.48 5.8Z",
    fill: "currentColor"
  }));
}